<template>
  <span>
    <div class="canvas-wrapper" style="width:400px;">
      <img class="img-fluid" src="@/assets/editor/start.png" v-if="type==='rps-scenario-start-title'" />
      <img class="img-fluid" src="@/assets/editor/start.png" v-if="type==='rps-scenario-start-description'" />
      <img class="img-fluid" src="@/assets/editor/end.png" v-if="type==='rps-scenario-completion-title'" />
      <img class="img-fluid" src="@/assets/editor/end.png" v-if="type==='rps-scenario-completion-description'" />
      <img class="img-fluid" src="@/assets/editor/game.png" v-if="type==='rps-case-answer-options'" />
      <img class="img-fluid" src="@/assets/editor/game.png" v-if="type==='rps-case-title'" />
      <img class="img-fluid" src="@/assets/editor/game.png" v-if="type==='rps-case-description'" />
      <img class="img-fluid" src="@/assets/editor/game.png" v-if="type==='rps-case-question'" />
      <img class="img-fluid" src="@/assets/editor/likert.png" v-if="type==='rps-case-description-above-cases'" />
      <img class="img-fluid" src="@/assets/editor/likert.png" v-if="type==='rps-case-description-below-cases'" />
      <canvas ref="myCanvas" class="canvas-overlay"></canvas>
    </div>
  </span>
</template>

<script>

// https://stackoverflow.com/a/60527412/76535

export default {
  props: ["type"],
  methods: {
  },
  mounted() {
    const c = this.$refs.myCanvas
    const canvas = c.getContext('2d')
    canvas.beginPath()
    canvas.lineWidth = "2";
    canvas.strokeStyle = "red";

    if (this.type === "rps-scenario-start-title") {
      canvas.rect(15, 60, 270, 16)
    }

    if (this.type === "rps-scenario-start-description") {
      canvas.rect(15, 75, 270, 50)
    }

    if (this.type === "rps-scenario-completion-title") {
      canvas.rect(15, 85, 270, 20)
    }

    if (this.type === "rps-scenario-completion-description") {
      canvas.rect(15, 105, 270, 38)
    }    

    if (this.type === "rps-case-answer-options") {
      canvas.rect(15, 60, 270, 50)
    }    

    if (this.type === "rps-case-title") {
      canvas.rect(15, 34, 270, 8)
    }    

    if (this.type === "rps-case-description") {
      canvas.rect(15, 40, 270, 13)
    }    

    if (this.type === "rps-case-question") {
      canvas.rect(15, 53, 270, 8)
    }    

    if (this.type === "rps-case-description-above-cases") {
      canvas.rect(110, 80, 100, 8)
    }    

    if (this.type === "rps-case-description-below-cases") {
      canvas.rect(110, 137, 100, 8)
    }    

    canvas.stroke()
  },
};
</script>

<style>
.canvas-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  width: 100%;
  height: 100%;
}

.canvas-wrapper {
  position: relative;
}
</style>
